import { ValueDistributor } from '../../../../utils/value-distributor';

export class CompletesDistributor<T extends { completes_required: number }> {
  constructor(
    private _surveys: T[],
    private _completesRequired: number,
    private readonly _isMultiCountryEnabled: boolean,
    private readonly _isMultiCountrySingleViewEnabled: boolean
  ) {}

  public distribute(): T[] {
    if (this._isMultiCountryEnabled) {
      return this._surveys;
    }

    if (this._isMultiCountrySingleViewEnabled) {
      const distribution = new ValueDistributor(
        this._completesRequired,
        this._surveys.length
      ).distribute();
      return this._surveys.map((survey, index) => {
        survey.completes_required = distribution[index];
        return survey;
      });
    }

    return this._surveys;
  }
}
